import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { FormType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/FormType'
import {
  Dashboard,
  DynamicRenderer
} from '@splunk-iteng/splunk-shared-components'

// eslint-disable-next-line import/no-cycle
import { initialState } from '../../store/slices/admin.slice'
// eslint-disable-next-line import/no-cycle
import { AppRoutes } from '../../routes/router'
import { AppFunction } from '../../auth/roles'
import { useAccessLevel } from '../../context/AccessLevelContext'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function View({ sharedState }: AppRoutes): JSX.Element {
  const [redirectPath, setRedirectPath] = useState<string | null>(null)
  const { path, taskId } = useParams()
  const { isAuthorized } = useAccessLevel()
  const [currentState, setCurrentState] = useState({})
  const [doSubmit, setDoSubmit] = useState(false)
  const setFormState = (attr: string, value: string) => {
    setDoSubmit(false)
    setCurrentState({ ...currentState, [attr]: value })
  }
  const clearState = useCallback(() => {
    setDoSubmit(false)
  }, [])

  useEffect(() => {
    setDoSubmit(false)
  }, [])

  useEffect(() => {
    setDoSubmit(false)
    setCurrentState({})
  }, [path, taskId])

  const navigate = useNavigate()
  const config = initialState.navigation.find((item) => item.name === path)
  const formsToRender = config.children.find(
    (item: FormType) => item.name === taskId
  )

  useEffect(() => {
    if (!config || !taskId) {
      setRedirectPath('/404')
    }

    if (!formsToRender) {
      setRedirectPath('/404')
    }

    if (formsToRender.requiredFunction) {
      const functionKey = formsToRender.requiredFunction as AppFunction
      if (!isAuthorized(functionKey)) {
        setRedirectPath('/unauthorized')
      }
    }
  }, [config, formsToRender, taskId, isAuthorized])

  useEffect(() => {
    if (redirectPath) {
      navigate(redirectPath)
    }
  }, [redirectPath, navigate])

  const onSubmitCallback = (attrsToAdd = {}) => {
    setCurrentState({ ...currentState, ...attrsToAdd })
    setDoSubmit(true)
  }
  const formSubmit = (e: any) => {
    e.preventDefault()
    setCurrentState({ ...currentState })
    setDoSubmit(true)
  }
  const {
    contentComponent: ContentComponent,
    description,
    formConfig,
    label
  } = formsToRender
  const children = formConfig.map((form: FormType, idx: number) => {
    const { containerClassName } = form
    return (
      <div
        className={containerClassName || 'p-8'}
        key={`${Math.random()}-${form.name}`}
      >
        <DynamicRenderer
          {...form}
          tabIndex={idx}
          currentState={currentState}
          setCurrentState={setFormState}
          onSubmitCallback={onSubmitCallback}
        />
      </div>
    )
  })
  const content = () => (
    <div>
      <form onSubmit={formSubmit}>{children}</form>
      <div className="content">
        <ContentComponent
          clearState={clearState}
          doSubmit={doSubmit}
          currentState={currentState}
          setCurrentState={setCurrentState}
        />
      </div>
    </div>
  )

  return (
    <Dashboard
      description={description}
      title={label}
      content={content}
      showContent
    />
  )
}
